import { css } from '@emotion/core';
import styled from '@emotion/styled';
import Colors from '@theme/colors';

const FormLabelStyle = () => css`
  color: ${Colors.neutral75};
  display: block;
  opacity: 0.6;
  margin-bottom: 10px;
  margin: 20px 10px 10px 0px;
`;

const FormLabel = styled.label`
  ${FormLabelStyle}
`;

export default FormLabel;
